<template>
    <div class="table_wrap">
        <div class="filter_wrap">
            <div class="filter_row">
                <div class="filter_content">
                    <div class="filter_titleBox mr15">
                        <span class="filter_title">가입일</span>
                    </div>
                    <div class="filter">
                        <el-date-picker
                                class="datePicker_long"
                                v-model="filterDate"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                @change="setFilterFunc('cr', filterDate)"
                                start-placeholder="시작일"
                                end-placeholder="종료일"
                                :editable="false"
                        >
                        </el-date-picker>
                    </div>
                </div>
              <div class="filter_content">
                <div class="filter_titleBox mr15">
                  <span class="filter_title">회원유형</span>
                </div>
                <div class="filter">
                  <el-select class="short" v-model="filterMemberType" @change="setFilterArrayFunc('pr', filterMemberType)">
                    <el-option :value="''" :label="'전체'"></el-option>
                    <el-option v-for="(data, value, index) in memberType" :key="`memberType${value}`" :label="data.name" :value="Number(value)"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="filter_row">
                <div class="filter_content">
                    <div class="filter_titleBox mr15">
                        <span class="filter_title">검색 구분</span>
                    </div>
                    <div class="filter mr10">
                        <el-select class="el-select" v-model="searchInputOption">
                            <el-option value="mid" :label="'아이디'"></el-option>
                            <el-option value="ni" :label="'닉네임'"></el-option>
                            <el-option value="na" :label="'이름'"></el-option>
                        </el-select>
                    </div>
                    <div class="filter">
                        <el-input v-model="searchInput" @keypress.enter.native="setFilterFunc(searchInputOption, searchInput)" placeholder="검색어를 입력해 주세요." class="littleShort mr10"></el-input>
                        <el-button class="com_search"  @click="setFilterFunc(searchInputOption, searchInput)">
                            검색
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="filter-show-count mt15 mb15">
            <el-select class="veryShort" v-model="size" @change="changePage('size', size)">
                <el-option v-for="(sizeData) in sizeList" :key="`size${sizeData}`" :value="sizeData"
                           :label="`${sizeData}개씩 보기`"></el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
    import memberUtil from "@/components/member/memberUtil";
    import {memberType,curatorType,memberStatus} from "@/service/memberService";
    import util from "@/mixins/util";
    const {filterConfig} = memberUtil;
    export default {
        name: "MemberFilterItemAutoLayout",
        mixins: [],
        components: {},
        inject: ['setPage', 'setFilter'],
        provide() {
            return {}
        },
        props: {
            filterData: {default: () => {}},
            paginationData: {default: {total: 0, page: 0, size: 0,}},
        },
        data() {
            return {
                filterDate: '',
                searchInputOption: 'mid',
                searchInput: '',
                filterMemberType : '',
                filterCuratorType : '',
                filterMemberStatus : '',
                memberType: memberType,
                curatorType : curatorType,
                memberStatus : memberStatus,
                size: 10,
                sizeList: [10, 30, 50],

            }
        },
        created() {
        },
        mounted() {
            this.setterFilterDataInData();
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            setterFilterDataInData() {
                let classnames = Object.keys(this.filterData);
                classnames.forEach(classname => {
                    let obj = this.filterData[classname];
                    let type = filterConfig[obj.key].type;
                    if (this.hasOwnProperty(classname)) {
                        if (type == 'query') {
                            this[classname] = obj.query;
                            if (this.hasOwnProperty(classname + 'Option')) {
                                this[classname + 'Option'] = obj.key;
                            }
                        } else if (type === 'between') {
                            this[classname] = [obj.start, obj.end];
                        } else if (type === 'match') {
                            let arr = obj.value.split(',');
                            if (arr.length > 1) {
                                let numArr = []
                                for (let i of arr) {
                                    numArr.push(Number(i))
                                };
                                this[classname] = numArr
                            } else if (isNaN(obj.value)) {
                                this[classname] = obj.value;
                            } else {
                                this[classname] = Number(obj.value);
                            }

                        }else if(type === 'terms') {
                            if(isNaN(obj.terms[0])) {
                                this[classname] = obj.terms[0];
                            }else{
                                this[classname] = Number(obj.terms[0]);
                            }

                        }

                    }
                })
                this.size = this.paginationData.size;
            },
            // 데이터가 1개이지만 array형식으로 보내야 할 때 사용
            setFilterArrayFunc(key, value) {
                let arr = []
                if (!util.isEmpty(value)) {
                    arr.push(value)
                }
                this.setFilter(key, arr);
            },
            setFilterFunc(key, value) {
                this.setFilter(key, value);
            },

            changePage(key, value) {
                this.setPage(key, value);
                this.setPage('page', 1);
            },
            checkFilterData() {
                return this.filterDate != null && this.filterDate.length > 0;
            },
        },
        watch: {},
    }
</script>

<style lang="scss">


</style>
